import { BlurView } from 'expo-blur';
import React, { type ReactNode } from 'react';
import { StyleSheet } from 'react-native';
import { isWeb, View, type ViewProps, YStack } from 'tamagui';

import { Shadows } from './Shadows';

export interface FrostedSurfaceProps extends Omit<ViewProps, 'children'> {
    children: ReactNode;
    borderRadius?: number;
}

export const FrostedSurface = ({
    children,
    borderRadius = 24,
    ...stackProps
}: FrostedSurfaceProps) => {
    return (
        <View
            pointerEvents="box-none"
            borderRadius={borderRadius}
            overflow="hidden"
            borderWidth={1}
            borderColor="$white"
            $platform-web={{
                backdropFilter: 'blur(16px)',
            }}
            {...Shadows.CONVERSATIONAL}
            {...stackProps}
        >
            {!isWeb ? (
                <BlurView
                    tint="light"
                    intensity={16}
                    pointerEvents="none"
                    style={StyleSheet.absoluteFill}
                />
            ) : null}
            <View
                pointerEvents="none"
                position="absolute"
                top={0}
                left={0}
                right={0}
                bottom={0}
                backgroundColor="rgba(255, 255, 255, 0.5)"
            />
            <YStack pointerEvents="auto" position="relative" zIndex={1}>
                {children}
            </YStack>
        </View>
    );
};
